import React, { useState, useEffect, Fragment } from 'react';
import loader from '../assets/img/svg/loader.svg';


const Loader = (props) => {
    //const [count, setCount] = useState(0);

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {

    });

    return (
        <Fragment>
             <div id="WIP_loader" style={{"zIndex":"9999 !important","display":props.show ? "block " : "none "}} className="lodr-overlay">
                    <div className="gif-loader">
                    <img src={loader} className="m-b-15" />
                    <p>Please wait...</p>
                    </div>
                </div>
        </Fragment>
    );
}

export default Loader;